/**
 * @module portal\menu
 */
import Vue from "vue";
import Component from "vue-class-component";
import GhBase from "../../components/ghBase";
import { TreeNode } from "element-ui/types/tree";
import { Watch } from "vue-property-decorator";
import GhTablePage from "@/components/ghTablePage/ghTablePage";

@Component
export default class Menu extends GhBase {
  private args = { parent_id: "", keyword: "" };
  private modelTemplate = { ParentId: "" };
  private parent: TreeNode<string, IndexObject> | null = null;
  private tabs: IGhTab[] = [
    { title: "系统菜单", drawer: true }
    // { title: "菜单维护", drawer: false }
  ];

  @Watch("parent")
  private observeParent() {
    if (this.parent) {
      this.args.parent_id = this.parent.key;
      this.modelTemplate.ParentId = this.parent.key;
      let table = this.$refs.table as GhTablePage;
      if (table) {
        table.query();
      }
    }
  }

  private configPage(item) {
    this.navigate("/portal/menu/config", item);
  }

  private beforeIntial(prop: ITableRowProps) {
    let options: { [key: string]: ITableRowOption } = {};
    if (prop.item && !prop.item.dynamic) {
      options["O-dynamic-config"] = {
        hideActions: ["config"]
      };
    }
    return options;
  }

  private get AllowAdd() {
    if (this.parent) {
      if (!this.parent.isLeaf) {
        return false;
      }
    }
    return true;
  }
}
